import React from 'react';
import {
  Typography,
  Card,
  CardContent,
  Grid,
  Button
} from '@mui/material';
import { CloudUpload as CloudUploadIcon } from '@mui/icons-material';

interface ClassificationSummaryProps {
  statistics: {
    total: number;
    relevant: number;
    undecided: number;
    outlier: number;
  };
  onExportResults: () => void;
}

const ClassificationSummary: React.FC<ClassificationSummaryProps> = ({
  statistics,
  onExportResults
}) => {
  return (
    <Card sx={{ p: 3 }}>
      <CardContent>
        <Typography variant="h6" gutterBottom>
          Classification Summary
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Total Keywords
            </Typography>
            <Typography variant="h4">
              {statistics.total}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Relevant Keywords
            </Typography>
            <Typography variant="h4" color="success.main">
              {statistics.relevant}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Undecided Keywords
            </Typography>
            <Typography variant="h4" color="warning.main">
              {statistics.undecided}
            </Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body2" color="text.secondary">
              Outlier Keywords
            </Typography>
            <Typography variant="h4" color="error.main">
              {statistics.outlier}
            </Typography>
          </Grid>
        </Grid>
        <Button
          fullWidth
          variant="outlined"
          sx={{ mt: 2 }}
          startIcon={<CloudUploadIcon />}
          onClick={onExportResults}
        >
          Export Results
        </Button>
      </CardContent>
    </Card>
  );
};

export default ClassificationSummary;
